import { colors } from './colors';
export const borders = {
  input: `1px solid ${colors.border}`
};